export type DateTimeV2 = Date

const format = (src: DateTimeV2): string => {
  const year = src.getFullYear()
  const month = toFullValue(src.getMonth() + 1)
  const date = toFullValue(src.getDate())
  const hour = toFullValue(src.getHours())
  const minutes = toFullValue(src.getMinutes())
  const seconds = toFullValue(src.getSeconds())
  return `${year}/${month}/${date} ${hour}:${minutes}:${seconds}`
}

const toFullValue = (v: number): string => {
  return v < 10 ? `0${v}` : v.toString()
}

const newFromString = (src: string): DateTimeV2 => {
  return new Date(src)
}

const fromVoToApiRequest = (src: DateTimeV2): number => {
  return src.getTime()
}
const fromApiResponseToVo = (
  src: string | number | undefined
): DateTimeV2 | undefined => {
  return src ? new Date(src) : undefined
}

const now = (): number => {
  return new Date().getTime()
}

export const dateTimeV2Service = {
  format,
  newFromString,
  fromVoToApiRequest,
  fromApiResponseToVo,
  now,
}
